import { add } from '../slicers/employeeSlicer'
import {useDispatch, useSelector } from 'react-redux';
import { useEffect } from "react";

function Get_employee () {
    const dispatch = useDispatch()
    const callKey = useSelector((state) => state.keySlicer.value)
    console.log(callKey)
    useEffect(() => {
        let xhr = new XMLHttpRequest(); 
        console.log(`${process.env.REACT_APP_BASEURL}`)
        let url = new URL(`${process.env.REACT_APP_BASEURL}employee/info`);
        xhr.open('GET', url, true)
        xhr.setRequestHeader('authtoken', callKey)
        xhr.setRequestHeader('Content-Type', 'application/json')
        xhr.responseType = 'json';
        xhr.send();
        xhr.onload = () => {
            if (xhr.status == 200) {
                    dispatch(add(xhr.response))
            } 
        } 
    }, []);
}
export default Get_employee;